import { Tooltip } from "@material-ui/core";
import { Info } from "@material-ui/icons";
import {
  PERMISSION_ROLE_HIS_PAYMENT,
  REQUIRED_CTKM_DISCOUNT,
} from "app/appConfig";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsAutocompleteTextAndSelect from "app/common/form/GlobitsAutocompleteTextAndSelect";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import IconDelete from "app/common/Icon/IconDelete";
import {
  INVOICE_NOREQUIRED_PAID,
  INVOICE_PAID,
  INVOICE_UNPAID,
  LIST_DATE_UNIT,
  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME,
} from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDate,
  getPriceTypeService,
  getPromotionCodes,
  getWarrantyPeriods,
  isAdmin,
  isRoleCashier,
  isRoleHisPayment,
  isRoleisRoleEditWarranty,
} from "app/common/LocalFunction";
import { pagingDrug } from "app/services/DrugService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef } from "react";
import DynamicTable from "./DynamicTable";

const PaServiceRegisterTable = ({ listVatPercent, selectedVoucher }) => {
  const SERVICE_TYPE = 1;
  const DRUG_TYPE = 2;
  const { values, setFieldValue } = useFormikContext();
  let isPaymentPermission = isRoleHisPayment();
  let listFreeCode = getPromotionCodes();
  let isAdminPermission = isAdmin();
  let isCashier = isRoleCashier();
  let isEditWarranty = isRoleisRoleEditWarranty();
  const hasPaidStatus = (status) => [INVOICE_PAID].includes(status);

  const handleOnchangeQuantityService = (e, index) => {
    let quantity = +e?.target?.value;
    const item = getIn(values, `paServiceRegister[${index}]`);

    // Tự động load lại giá theo cấu hình số lượng
    const patientTypeService = getIn(values, "patientTypeService");
    const usingServiceFees = item?.service?.serviceFeeList?.filter((f) => f?.isUsing) || [];
    const feeItemSerive = getPriceTypeService(patientTypeService, usingServiceFees, quantity);

    let price = item?.price || 0;
    if (feeItemSerive) {
      price = feeItemSerive.price;
      setFieldValue(`paServiceRegister[${index}].price`, price);
      setFieldValue(`paServiceRegister[${index}].patientTypeService`, {
        ...feeItemSerive,
        id: feeItemSerive?.patientTypeService?.id,
        name: feeItemSerive?.patientTypeService?.name,
        code: feeItemSerive?.patientTypeService?.code,
      });
      setFieldValue(`paServiceRegister[${index}].priceWithTax`, feeItemSerive?.vatIncluded);
      const taxPercent = feeItemSerive?.serviceVAT?.vatPercent?.toString() || 0;
      setFieldValue(`paServiceRegister[${index}].taxPercent`, taxPercent);
      item.taxPercent = taxPercent;
    }

    const percentDiscount = item?.percentDiscount || 0;
    let newDiscount = item?.discount;
    let newAmount =
      quantity * price - ((quantity * price * percentDiscount) / 100 || 0);

    // Clear CTKM khi thay đổi số lượng để tránh vi phạm ràng buộc minInvoiceAmount
    const hasCTKM = !!item?.promotionProgram;
    if (hasCTKM) {
      newAmount = quantity * price;
      newDiscount = 0;
      setFieldValue(`paServiceRegister[${index}].promotionProgram`, null);
      setFieldValue(`paServiceRegister[${index}].discount`, 0);
      setFieldValue(`paServiceRegister[${index}].percentDiscount`, 0);
    }

    setFieldValue(`paServiceRegister[${index}].amount`, newAmount);

    if (percentDiscount && !hasCTKM) {
      newDiscount = (percentDiscount * quantity * price) / 100;
      setFieldValue(`paServiceRegister[${index}].discount`, newDiscount);
    }

    if (!values?.isTotalPriceUsed) {
      // Sử dụng newDiscount thay vì item?.discount để tính đúng khi clear CTKM
      let newTaxTotal =
        ((price * quantity - (newDiscount || 0)) * (item?.taxPercent || 0)) /
        100;
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * quantity,
        newDiscount,
        newTaxTotal,
        index,
        type: SERVICE_TYPE,
      });

      setFieldValue("totalAmount", newTotal.totalAmount);
      setFieldValue("taxTotal", newTotal.taxTotal);
      setFieldValue("discount", newTotal.discount);
    }

    let totalVolumeSold = 0;

    // tinh tong so cc ban
    if (item?.service?.volumePerService) {
      totalVolumeSold = quantity * item?.service?.volumePerService;
    }
    setFieldValue(
      `paServiceRegister[${index}].totalVolumeSold`,
      totalVolumeSold
    );

    handleResetWarrantyPeriod(index);
  };

  const handleOnchangePriceService = async (e, index) => {
    //sửa giá => thay đổi giảm giá,thuế ,ở từng item,thay đổi thành tiền,giảm giá,thuế ở trên
    //TH đặc biệt nếu tính theo giá tổng mà thành tiền > tổng giá các dv => tự set lại giảmgiá chia đều item
    let price = +e?.target?.value;

    const item = getIn(values, `paServiceRegister[${index}]`);
    const taxPercent = item?.taxPercent || 0;
    const percentDiscount = item?.percentDiscount || 0;
    const quantity = item?.quantity || 0;
    let taxTotalItem = 0;
    const priceWithTax = item?.priceWithTax;
    let newTaxTotal = 0;
    const newDiscount = (quantity * price * percentDiscount) / 100;
    await setFieldValue(`paServiceRegister[${index}].discount`, newDiscount); // sửa giá thì sửa cả giảm giá
    setFieldValue(
      `paServiceRegister[${index}].amount`,
      quantity * price - (newDiscount || 0)
    );
    if (priceWithTax) {
      taxTotalItem =
        ((price * quantity - (newDiscount || 0)) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotalItem =
        (price * quantity - (newDiscount || 0)) * ((+taxPercent || 0) / 100);
    }
    setFieldValue(`paServiceRegister[${index}].taxTotal`, taxTotalItem);

    if (!values?.isTotalPriceUsed) {
      if (!item?.priceWithTax) {
        // nếu thay đổi giá thì thuế cx sẽ thay đổi

        newTaxTotal = ((price - newDiscount) * taxPercent) / 100;
      }

      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * quantity,
        newDiscount,
        newTaxTotal,
        index,
        type: SERVICE_TYPE,
      });

      await setFieldValue("totalAmount", newTotal.totalAmount);
      await setFieldValue("taxTotal", newTotal.taxTotal);
      await setFieldValue("discount", newTotal.discount);
    } else {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * quantity,
        newDiscount,
        newTaxTotal,
        index,
        type: SERVICE_TYPE,
      });
      if (values?.totalAmount < newTotal.totalAmount) {
        const percentAllocateItem =
          (newTotal.totalAmount - values?.totalAmount) / newTotal.totalAmount;
        const formatDataService = values?.paServiceRegister?.map((el, ind) => {
          let discount =
            percentAllocateItem *
            (ind === index ? price : el?.price) *
            (el?.unLimited ? 1 : el?.quantity);
          let taxTotal;
          if (el?.priceWithTax) {
            taxTotal =
              ((price * el?.quantity - (el?.discount || 0)) /
                (+taxPercent + 100)) *
              +taxPercent;
          } else {
            taxTotal =
              (price * el?.quantity - (el?.discount || 0)) *
              ((+taxPercent || 0) / 100);
          }
          return {
            ...el,
            price: ind === index ? price : el?.price,
            percentDiscount: percentAllocateItem,
            discount,
            taxTotal,
          };
        });

        setFieldValue(`paServiceRegister`, formatDataService);
      }
    }
    handleResetWarrantyPeriod(index);
  };

  const handleOnchangePriceDrug = async (e, index) => {
    let price = +e?.target?.value;

    const item = getIn(values, `drugs[${index}]`);
    const percentDiscount = item?.percentDiscount || 0;
    const soldQuantity = item?.soldQuantity || 0;
    let newTaxTotal = 0;

    const newDiscount = (soldQuantity * price * percentDiscount) / 100;
    await setFieldValue(`drugs[${index}].discount`, newDiscount); // sửa giá thì sửa cả giảm giá
    setFieldValue(
      `drugs[${index}].amount`,
      soldQuantity * price - (newDiscount || 0)
    );
    const taxPercent = +item?.taxPercent || 0;

    if (!values?.isTotalPriceUsed) {
      if (!item?.priceWithTax) {
        // nếu thay đổi giá thì thuế cx sẽ thay đổi
        newTaxTotal = ((price - newDiscount) * taxPercent) / 100;
      }

      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * soldQuantity,
        newDiscount,
        newTaxTotal,
        index,
        type: DRUG_TYPE,
      });

      await setFieldValue("totalAmount", newTotal.totalAmount);
      await setFieldValue("taxTotal", newTotal.taxTotal);
      await setFieldValue("discount", newTotal.discount);
    } else {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * soldQuantity,
        newDiscount,
        newTaxTotal,
        index,
        type: DRUG_TYPE,
      });
      if (values?.totalAmount < newTotal.totalAmount) {
        const percentAllocateItem =
          (newTotal.totalAmount - values?.totalAmount) / newTotal.totalAmount;
        const formatDataDrug = values?.drugs?.map((el, ind) => ({
          ...el,
          price: ind === index ? price : el?.price,
          percentDiscount: percentAllocateItem,
          discount:
            percentAllocateItem *
            (ind === index ? price : el?.price) *
            (el?.unLimited ? 1 : el?.quantity),
        }));

        setFieldValue(`drugs`, formatDataDrug);
      }
    }
  };

  const handleOnchangeQuantityDrug = (e, index) => {
    let soldQuantity = +e?.target?.value;

    const item = getIn(values, `drugs[${index}]`);
    const price = item?.price || 0;
    const percentDiscount = item?.percentDiscount || 0;
    let newDiscount = item?.discount;
    let newAmount = soldQuantity * price - ((soldQuantity * price * percentDiscount) / 100 || 0);

    // Clear CTKM khi thay đổi số lượng để tránh vi phạm ràng buộc minInvoiceAmount
    const hasCTKM = !!item?.promotionProgram;
    if (hasCTKM) {
      newAmount = soldQuantity * price;
      newDiscount = 0;
      setFieldValue(`drugs[${index}].promotionProgram`, null);
      setFieldValue(`drugs[${index}].discount`, 0);
      setFieldValue(`drugs[${index}].percentDiscount`, 0);
    }

    setFieldValue(`drugs[${index}].amount`, newAmount);

    // Chỉ tính lại discount nếu không có CTKM (vì đã clear ở trên)
    if (percentDiscount && !hasCTKM) {
      newDiscount = (percentDiscount * soldQuantity * price) / 100;

      setFieldValue(`drugs[${index}].discount`, newDiscount);
    }

    if (!values?.isTotalPriceUsed) {
      // Sử dụng newDiscount thay vì item?.discount để tính đúng khi clear CTKM
      let newTaxTotal =
        ((price * soldQuantity - (newDiscount || 0)) *
          (item?.taxPercent || 0)) /
        100;

      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * soldQuantity,
        newDiscount,
        newTaxTotal,
        index,
        type: DRUG_TYPE,
      });

      setFieldValue("totalAmount", newTotal.totalAmount);
      setFieldValue("taxTotal", newTotal.taxTotal);
      setFieldValue("discount", newTotal.discount);
    }
  };

  const handleOnChangeServiceDiscount = (e, index) => {
    let discount = +e?.target?.value || 0;
    let newTaxTotal = 0;
    let taxTotalItem = 0;
    const item = getIn(values, `paServiceRegister[${index}]`);
    const priceWithTax = item?.priceWithTax;
    const taxPercent = item?.taxPercent || 0;
    const price = item?.price || 0;
    const quantity = item?.quantity || 1;
    setFieldValue(`paServiceRegister[${index}].discount`, discount);
    setFieldValue(
      `paServiceRegister[${index}].amount`,
      price * quantity - discount
    );

    if (priceWithTax) {
      taxTotalItem =
        ((price * quantity - (discount || 0)) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotalItem =
        (price * quantity - (discount || 0)) * ((+taxPercent || 0) / 100);
    }
    setFieldValue(`paServiceRegister[${index}].taxTotal`, taxTotalItem);

    if (!item?.priceWithTax) {
      // nếu thay đổi giá thì thuế cx sẽ thay đổi
      const taxPercent = item?.taxPercent || 0;
      newTaxTotal = ((price - discount) * taxPercent) / 100;
    }
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * quantity,
        newDiscount: discount,
        newTaxTotal,
        index,
        type: SERVICE_TYPE,
      });
      setFieldValue("discount", newTotal.discount);

      setFieldValue("taxTotal", newTotal.taxTotal);
    }

    if (item?.price) {
      const percentDiscount = (discount / (item?.price * item?.quantity)) * 100;
      setFieldValue(
        `paServiceRegister[${index}].percentDiscount`,
        percentDiscount
      );
    }
    handleResetWarrantyPeriod(index);
  };

  const handleOnChangeDrugsDiscount = (e, index) => {
    let discount = +e?.target?.value || 0;
    let newTaxTotal = 0;
    const item = getIn(values, `drugs[${index}]`);
    let taxTotalItem = 0;
    const priceWithTax = item?.priceWithTax;
    const soldQuantity = item?.soldQuantity || 1;
    const price = item?.price || 0;
    const taxPercent = item?.taxPercent || 0;

    setFieldValue(`drugs[${index}].discount`, discount);
    setFieldValue(`drugs[${index}].amount`, soldQuantity * price - discount);
    if (priceWithTax) {
      taxTotalItem =
        ((price * soldQuantity - (discount || 0)) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotalItem =
        (price * soldQuantity - (discount || 0)) * ((+taxPercent || 0) / 100);
    }
    setFieldValue(`drugs[${index}].taxTotal`, taxTotalItem);

    if (!priceWithTax) {
      // nếu thay đổi giá thì thuế cx sẽ thay đổi
      const taxPercent = item?.taxPercent || 0;
      newTaxTotal = ((price - discount) * taxPercent) / 100;
    }
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * soldQuantity,
        newDiscount: discount,
        newTaxTotal,
        index,
        type: DRUG_TYPE,
      });
      setFieldValue("discount", newTotal.discount);
      setFieldValue("taxTotal", newTotal.taxTotal);
    }

    if (item?.price) {
      const percentDiscount =
        (discount / (item?.price * item?.soldQuantity)) * 100;

      setFieldValue(`drugs[${index}].percentDiscount`, percentDiscount);
    }
  };

  const handleOnChangeServiceOldCredit = (e, index) => {
    let oldCredit = +e?.target?.value || 0;
    let newTaxTotal = 0;
    const item = getIn(values, `paServiceRegister[${index}]`);

    const price = item?.price || 0;
    const quantity = item?.quantity || 1;
    let newDiscount = item?.discount || 0;
    setFieldValue(`paServiceRegister[${index}].oldCredit`, oldCredit);

    // Clear CTKM khi thay đổi tiền khấu trừ để tránh vi phạm ràng buộc minInvoiceAmount
    if (item?.promotionProgram) {
      const newAmount = price * quantity;
      newDiscount = 0; // Cập nhật newDiscount = 0 khi clear CTKM
      setFieldValue(`paServiceRegister[${index}].promotionProgram`, null);
      setFieldValue(`paServiceRegister[${index}].discount`, 0);
      setFieldValue(`paServiceRegister[${index}].percentDiscount`, 0);
      setFieldValue(`paServiceRegister[${index}].amount`, newAmount);
    }

    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: price * quantity,
      newDiscount: newDiscount, // Sử dụng newDiscount thay vì discount cũ
      newTaxTotal,
      newOldCredit: oldCredit,
      index,
      type: SERVICE_TYPE,
    });
    // setFieldValue("totalAmount", newTotal.totalAmount);
    setFieldValue("oldTreatmentCredit", newTotal.oldCredit);
    setFieldValue("oldCredit", newTotal.oldCredit);
    setFieldValue("discount", newTotal.discount); // Cập nhật tổng discount
  };

  const handleOnChangeDrugsOldCredit = (e, index) => {
    let oldCredit = +e?.target?.value || 0;
    let newTaxTotal = 0;
    const item = getIn(values, `drugs[${index}]`);

    const soldQuantity = item?.soldQuantity || 1;
    const price = item?.price || 0;
    let newDiscount = item?.discount || 0;

    setFieldValue(`drugs[${index}].oldCredit`, oldCredit);

    // Clear CTKM khi thay đổi tiền khấu trừ để tránh vi phạm ràng buộc minInvoiceAmount
    if (item?.promotionProgram) {
      const newAmount = price * soldQuantity;
      newDiscount = 0; // Cập nhật newDiscount = 0 khi clear CTKM
      setFieldValue(`drugs[${index}].promotionProgram`, null);
      setFieldValue(`drugs[${index}].discount`, 0);
      setFieldValue(`drugs[${index}].percentDiscount`, 0);
      setFieldValue(`drugs[${index}].amount`, newAmount);
    }

    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: price * soldQuantity,
      newDiscount: newDiscount, // Sử dụng newDiscount thay vì discount cũ
      newTaxTotal,
      newOldCredit: oldCredit,
      index,
      type: DRUG_TYPE,
    });
    setFieldValue("oldTreatmentCredit", newTotal.oldCredit);
    setFieldValue("oldCredit", newTotal.oldCredit);
    setFieldValue("discount", newTotal.discount); // Cập nhật tổng discount
  };

  const handleOnChangeDrugsPercentDiscount = (e, index) => {
    let percentDiscount = +e?.target?.value;
    let newTaxTotal = 0;

    const item = getIn(values, `drugs[${index}]`);
    const soldQuantity = item?.soldQuantity || 0;
    const price = item?.price || 0;
    let taxTotalItem = 0;
    const priceWithTax = item?.priceWithTax;
    const taxPercent = item?.taxPercent || 0;
    const discount = (percentDiscount * soldQuantity * price) / 100;

    if (priceWithTax) {
      taxTotalItem =
        ((price * soldQuantity - (discount || 0)) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotalItem =
        (price * soldQuantity - (discount || 0)) * ((+taxPercent || 0) / 100);
    }
    setFieldValue(`drugs[${index}].taxTotal`, taxTotalItem);

    if (!priceWithTax) {
      // nếu thay đổi giá thì thuế cx sẽ thay đổi
      const taxPercent = item?.taxPercent || 0;
      newTaxTotal = ((price - discount) * taxPercent) / 100;
    }
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * soldQuantity,
        newDiscount: discount,
        newTaxTotal,
        index,
        type: DRUG_TYPE,
      });
      setFieldValue("discount", newTotal.discount);
      setFieldValue("taxTotal", newTotal.taxTotal);
    }
    if (item?.price) {
      const percentDiscount =
        (discount / (item?.price * item?.soldQuantity)) * 100;
      setFieldValue(`drugs[${index}].percentDiscount`, percentDiscount);
    }
    setFieldValue(`drugs[${index}].percentDiscount`, percentDiscount);
    setFieldValue(`drugs[${index}].discount`, discount);
    setFieldValue(
      `drugs[${index}].amount`,
      soldQuantity * price - (discount || 0)
    );
  };

  const handleOnChangeServicesPercentDiscount = (e, index) => {
    let percentDiscount = +e?.target?.value;
    let newTaxTotal = 0;
    const item = getIn(values, `paServiceRegister[${index}]`);

    let price = item?.price || 0;
    let quantity = item?.quantity || 0;
    const discount = (percentDiscount * quantity * price) / 100;
    let taxTotalItem = 0;
    const priceWithTax = item?.priceWithTax;
    const taxPercent = item?.taxPercent || 0;

    if (priceWithTax) {
      taxTotalItem =
        ((price * quantity - (discount || 0)) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotalItem =
        (price * quantity - (discount || 0)) * ((+taxPercent || 0) / 100);
    }
    setFieldValue(`paServiceRegister[${index}].taxTotal`, taxTotalItem);

    if (!priceWithTax) {
      // nếu thay đổi giá thì thuế cx sẽ thay đổi
      const taxPercent = item?.taxPercent || 0;
      newTaxTotal = ((price - discount) * taxPercent) / 100;
    }
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: price * quantity,
        newDiscount: discount,
        newTaxTotal,
        index,
        type: SERVICE_TYPE,
      });

      setFieldValue("discount", newTotal.discount);
      setFieldValue("taxTotal", newTotal.taxTotal);
    }

    setFieldValue(
      `paServiceRegister[${index}].percentDiscount`,
      percentDiscount
    );
    setFieldValue(`paServiceRegister[${index}].discount`, discount);
    setFieldValue(
      `paServiceRegister[${index}].amount`,
      quantity * price - (discount || 0)
    );
    handleResetWarrantyPeriod(index);
  };

  const handleDeleteService = async (index) => {
    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: 0,
      newDiscount: 0,
      newTaxTotal: 0,
      index,
      type: SERVICE_TYPE,
    });
    setFieldValue("totalAmount", newTotal.totalAmount);
    setFieldValue("taxTotal", newTotal.taxTotal);
    setFieldValue("discount", newTotal.discount);
    const paServiceRegister = getIn(values, "paServiceRegister") || [];
    const deleteItem = paServiceRegister[index];

    const newPaServiceRegister = paServiceRegister?.filter((el, ind) => {
      if (ind === index) return false;

      if (deleteItem?.id && el?.baseServiceId === deleteItem?.id) {
        return false;
      }

      return true;
    });
    let formatDataService;
    let formatDataDrug;
    const oldTreatmentCredit = +values?.oldTreatmentCredit || 0;
    if (oldTreatmentCredit >= 0) {
      const percentOldCreditItem =
        oldTreatmentCredit / (values?.totalAmount - (values?.discount || 0)); // tính % có thể phân bổ xuống
      formatDataService = newPaServiceRegister?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);
        return {
          ...el,
          oldCredit: el?.amount > 0 ? oldCredit : 0,
        };
      });

      formatDataDrug = values?.drugs?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);

        return {
          ...el,
          oldCredit: el?.amount > 0 ? oldCredit : 0,
        };
      });

      //  kiểm tra tổng
      let allocatedTotalSv =
        formatDataService?.length > 0
          ? formatDataService.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotalDrug =
        formatDataDrug?.length > 0
          ? formatDataDrug.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotal = allocatedTotalSv + allocatedTotalDrug;

      let diff = +(oldTreatmentCredit - allocatedTotal);

      //  cộng/trừ chênh lệch vào item cuối cùng
      if (diff !== 0) {
        if (formatDataDrug?.length > 0) {
          formatDataDrug[formatDataDrug.length - 1].oldCredit =
            +formatDataDrug[formatDataDrug.length - 1].oldCredit + diff;
        } else if (formatDataService?.length > 0) {
          formatDataService[formatDataService.length - 1].oldCredit =
            +formatDataService[formatDataService.length - 1]?.oldCredit + diff;
        }
      }
    }
    setFieldValue("paServiceRegister", formatDataService);
    setFieldValue("drugs", formatDataDrug);

    // await remove(index);
  };

  const handleDeleteDrugs = async (index, remove) => {
    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: 0,
      newDiscount: 0,
      newTaxTotal: 0,
      index,
      type: DRUG_TYPE,
    });
    setFieldValue("totalAmount", newTotal.totalAmount);
    setFieldValue("taxTotal", newTotal.taxTotal);
    setFieldValue("discount", newTotal.discount);
    let formatDataService;
    let formatDataDrug;
    const drugs = getIn(values, "drugs") || [];

    const deleteItem = drugs[index];
    const newDrugs = drugs?.filter((el, ind) => {
      if (ind === index) return false;

      if (deleteItem?.id && el?.baseServiceId === deleteItem?.id) {
        return false;
      }

      return true;
    });

    let oldTreatmentCredit = +values?.oldTreatmentCredit || 0;
    // xử lí nếu khấu trừ > 0 thì phân bổ tiền khấu trừ lại
    if (oldTreatmentCredit >= 0) {
      const percentOldCreditItem =
        oldTreatmentCredit / (values?.totalAmount - (values?.discount || 0)); // tính % có thể phân bổ xuống
      formatDataService = values?.paServiceRegister?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);
        return {
          ...el,
          oldCredit: el?.amount > 0 ? oldCredit : 0,
        };
      });

      formatDataDrug = newDrugs?.map((el, ind) => {
        const oldCredit = percentOldCreditItem * (el?.amount || 0);

        return {
          ...el,
          oldCredit: el?.amount > 0 ? oldCredit : 0,
        };
      });

      //  kiểm tra tổng
      let allocatedTotalSv =
        formatDataService?.length > 0
          ? formatDataService.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotalDrug =
        formatDataDrug?.length > 0
          ? formatDataDrug.reduce((sum, el) => sum + +el.oldCredit, 0)
          : 0;
      let allocatedTotal = allocatedTotalSv + allocatedTotalDrug;

      let diff = +(oldTreatmentCredit - allocatedTotal);

      //  cộng/trừ chênh lệch vào item cuối cùng
      if (diff !== 0) {
        if (formatDataDrug?.length > 0) {
          formatDataDrug[formatDataDrug.length - 1].oldCredit =
            +formatDataDrug[formatDataDrug.length - 1].oldCredit + diff;
        } else if (formatDataService?.length > 0) {
          formatDataService[formatDataService.length - 1].oldCredit =
            +formatDataService[formatDataService.length - 1]?.oldCredit + diff;
        }
      }
    }
    setFieldValue("paServiceRegister", formatDataService);
    setFieldValue("drugs", formatDataDrug);
  };

  const handleOnChangePatientTypeServiceService = (value, index) => {
    const item = getIn(values, `paServiceRegister[${index}]`);
    let taxTotalVatInclude = 0;
    let taxTotal = 0;

    setFieldValue(`paServiceRegister[${index}].patientTypeService`, value);
    let vatPercent = +value?.serviceVAT?.vatPercent || 0;
    const newDiscount =
      (value?.price * item?.quantity * item?.percentDiscount) / 100;

    setFieldValue(`paServiceRegister[${index}].price`, value?.price);
    setFieldValue(`paServiceRegister[${index}].discount`, newDiscount);
    setFieldValue(
      `paServiceRegister[${index}].amount`,
      (item?.quantity || 1) * value?.price - (newDiscount || 0)
    );
    setFieldValue(
      `paServiceRegister[${index}].priceWithTax`,
      value?.vatIncluded
    );
    setFieldValue(
      `paServiceRegister[${index}].taxPercent`,
      vatPercent?.toString()
    );
    //set lại tiền thuế

    if (value?.vatIncluded) {
      taxTotalVatInclude =
        ((value?.price * item?.quantity - (newDiscount || 0)) /
          (vatPercent + 100)) *
        vatPercent;
    } else {
      taxTotal =
        (value?.price * item?.quantity - (newDiscount || 0)) *
        (+vatPercent / 100);
    }

    //set lại tổng
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: value?.price * item?.quantity,
        newDiscount,
        taxTotal,
        index,
        type: SERVICE_TYPE,
      });

      setFieldValue(`discount`, newTotal.discount);
      setFieldValue(`taxTotal`, newTotal.taxTotal);
      setFieldValue(`totalAmount`, newTotal.totalAmount);
    }
    setFieldValue(
      `paServiceRegister[${index}].taxTotal`,
      +taxTotal + +taxTotalVatInclude
    );
    handleResetWarrantyPeriod(index);
  };

  const handleOnChangePatientTypeServiceDrug = (value, index) => {
    const item = getIn(values, `drugs[${index}]`);
    let taxTotalVatInclude = 0;
    let taxTotal = 0;
    const newDiscount =
      (value?.price * item?.soldQuantity * item?.percentDiscount) / 100;

    setFieldValue(`drugs[${index}].patientTypeService`, value);
    let vatPercent = +value?.serviceVAT?.vatPercent || 0;
    setFieldValue(`drugs[${index}].price`, value?.price);
    setFieldValue(`drugs[${index}].priceWithTax`, value?.vatIncluded);
    setFieldValue(`drugs[${index}].discount`, value?.newDiscount);
    setFieldValue(`drugs[${index}].taxPercent`, vatPercent?.toString());
    setFieldValue(
      `drugs[${index}].amount`,
      (item?.soldQuantity || 1) * value?.price - (newDiscount || 0)
    );
    //set lại tiền thuế

    if (value?.vatIncluded) {
      taxTotalVatInclude =
        ((value?.price * item?.quantity - (item?.discount || 0)) /
          (vatPercent + 100)) *
        vatPercent;
    } else {
      taxTotal =
        (value?.price * item?.quantity - (item?.discount || 0)) *
        (+vatPercent / 100);
    }

    //set lại thành tiền
    if (!values?.isTotalPriceUsed) {
      const newTotal = handleReduceTotalAmountService({
        newTotalAmount: value?.price * item?.soldQuantity,
        newDiscount,
        taxTotal,
        index,
        type: DRUG_TYPE,
      });

      setFieldValue(`discount`, newTotal.discount);
      setFieldValue(`taxTotal`, newTotal.taxTotal);
      setFieldValue(`totalAmount`, newTotal.totalAmount);
    }

    setFieldValue(`drugs[${index}].taxTotal`, +taxTotal + +taxTotalVatInclude);
  };

  const handleOnchangeTaxTotalServices = (newTaxTotal, index) => {
    const oldTaxTotal = getIn(values, `paServiceRegister.[${index}].taxTotal`);
    const taxTotal = (+values?.taxTotal || 0) + +newTaxTotal - oldTaxTotal;
    setFieldValue("taxTotal", taxTotal);
  };

  const handleOnchangeTaxTotalDrugs = (newTaxTotal, index) => {
    const oldTaxTotal = getIn(values, `drugs.[${index}].taxTotal`);
    const taxTotal = (+values?.taxTotal || 0) + +newTaxTotal - oldTaxTotal;
    setFieldValue("taxTotal", taxTotal);
  };

  const handleOnChangeService = (value, index) => {
    let taxTotal = 0;
    let taxTotalVatInclude = 0;
    const feeItem =
      value?.serviceFeeList?.length > 0
        ? getPriceTypeService(null, value?.serviceFeeList || [])
        : null;
    const price = feeItem?.price ? +feeItem?.price : 0;

    let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;
    if (feeItem?.vatIncluded) {
      taxTotalVatInclude =
        ((feeItem?.price * 1) / (+taxPercent + 100)) * +taxPercent;
    } else {
      taxTotal = feeItem?.price * 1 * ((+taxPercent || 0) / 100);
    }

    let newService = {
      service: value,
      name: value?.tradeName || value?.name,
      quantity: 1,
      currentEdit: true,
      price,
      amount: price,
      fees: value?.serviceFeeList?.map((el) => ({
        ...el?.patientTypeService,
        price: el?.price,
        vatIncluded: el?.vatIncluded,
        serviceVAT: el?.serviceVAT,
        patientTypeService: el?.patientTypeService,
      })),
      patientTypeService: feeItem,
      priceWithTax: value?.vatIncluded,
      taxTotal: taxTotalVatInclude + taxTotal,
      taxPercent,
      discount: 0,
      percentDiscount: 0,
    };

    setFieldValue(`paServiceRegister[${index}]`, newService);

    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: price,
      newDiscount: 0,
      newTaxTotal: taxTotal,
      index,
      type: SERVICE_TYPE,
    });
    setFieldValue("totalAmount", newTotal.totalAmount);
    setFieldValue("discount", newTotal.discount);
    setFieldValue("taxTotal", newTotal.taxTotal);
  };

  const handleOnChangeDrug = (value, index) => {
    let taxTotal = 0;
    let taxTotalVatInclude = 0;
    const feeItem =
      value?.drugUnitPrices?.length > 0
        ? getPriceTypeService(null, value?.drugUnitPrices || [])
        : null;
    const price = feeItem?.price ? +feeItem?.price : 0;

    let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;
    if (feeItem?.vatIncluded) {
      taxTotalVatInclude =
        ((feeItem?.price * 1) / (+taxPercent + 100)) * +taxPercent;
    } else {
      taxTotal = feeItem?.price * 1 * ((+taxPercent || 0) / 100);
    }

    let newDrug = {
      drugs: value,
      name: value?.tradeName || value?.name,
      soldQuantity: 1,
      currentEdit: true,
      price,
      amount: price,
      fees: value?.drugUnitPrices?.map((el) => ({
        ...el?.patientTypeService,
        price: el?.price,
        vatIncluded: el?.vatIncluded,
        serviceVAT: el?.serviceVAT,
        patientTypeService: el?.patientTypeService,
      })),
      patientTypeService: feeItem,
      priceWithTax: value?.vatIncluded,
      taxTotal: taxTotalVatInclude + taxTotal,
      taxPercent,
      discount: 0,
      percentDiscount: 0,
    };

    setFieldValue(`paServiceRegister[${index}]`, newDrug);

    const newTotal = handleReduceTotalAmountService({
      newTotalAmount: price,
      newDiscount: 0,
      newTaxTotal: taxTotal,
      index,
      type: DRUG_TYPE,
    });
    setFieldValue("totalAmount", newTotal.totalAmount);
    setFieldValue("discount", newTotal.discount);
    setFieldValue("taxTotal", newTotal.taxTotal);
  };

  const handleReduceTotalAmountService = ({
    newTotalAmount = 0,
    newDiscount = 0,
    newTaxTotal = 0,
    newOldCredit = 0,
    index,
    type, // service
  }) => {
    const totalAmountServices = (values?.paServiceRegister || [])?.reduce(
      (acc, curr, ind) => {
        if (index === ind && type === SERVICE_TYPE) {
          return {
            totalAmount: acc.totalAmount + newTotalAmount,
            discount: acc.discount + newDiscount,
            oldCredit: +acc.oldCredit + +newOldCredit,
            taxTotal: curr?.priceWithTax
              ? acc.taxTotal
              : +acc.taxTotal + +newTaxTotal,
          };
        } else {
          const taxTotal =
            (((curr?.quantity || 1) * curr?.price - (curr?.discount || 0)) *
              curr?.taxPercent) /
            100;

          return {
            totalAmount: acc.totalAmount + (curr?.quantity || 1) * curr?.price,
            discount: acc.discount + (curr?.discount || 0),
            oldCredit: +acc.oldCredit + (+curr?.oldCredit || 0),
            taxTotal: curr?.priceWithTax
              ? acc.taxTotal
              : +acc.taxTotal + taxTotal,
          };
        }
      },
      {
        totalAmount: 0,
        discount: 0,
        taxTotal: 0,
        oldCredit: 0,
      }
    );

    const totalAmountDrugs = (values?.drugs || [])?.reduce(
      (acc, curr, ind) => {
        if (index === ind && type === DRUG_TYPE) {
          return {
            totalAmount: acc.totalAmount + newTotalAmount,
            discount: acc.discount + newDiscount,
            oldCredit: +acc.oldCredit + +newOldCredit,
            taxTotal: curr?.priceWithTax
              ? acc.taxTotal
              : +acc.taxTotal + +newTaxTotal,
          };
        } else {
          const taxTotal =
            (((curr?.soldQuantity || 1) * curr?.price - (curr?.discount || 0)) *
              curr?.taxPercent) /
            100;
          return {
            totalAmount:
              acc.totalAmount + (curr?.soldQuantity || 1) * curr?.price,
            discount: acc.discount + (curr?.discount || 0),
            oldCredit: +acc.oldCredit + (+curr?.oldCredit || 0),
            taxTotal: curr?.priceWithTax
              ? acc.taxTotal
              : +acc.taxTotal + taxTotal,
          };
        }
      },
      {
        totalAmount: 0,
        discount: 0,
        taxTotal: 0,
        oldCredit: 0,
      }
    );

    return {
      totalAmount:
        +totalAmountServices?.totalAmount + +totalAmountDrugs?.totalAmount,
      discount: +totalAmountServices?.discount + +totalAmountDrugs?.discount,
      taxTotal: +totalAmountServices?.taxTotal + +totalAmountDrugs?.taxTotal,
      oldCredit: +totalAmountServices?.oldCredit + +totalAmountDrugs?.oldCredit,
    };
  };

  const columns = [
    {
      title: "STT",
      width: "3%",
      render: ({ fullIndex }) => fullIndex + 1,
      align: "center",
    },
    {
      title: "Thao tác",
      width: "5%",
      align: "center",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        const isLocked =
          type === "paServiceRegister" && (item?.totalPerformedTimes || 0) > 0;
        const rowDisabled = hasPaidStatus(item?.paymentStatus);
        if (!editable || isLocked || rowDisabled) return null;
        return (
          <span
            className="pointer"
            onClick={() => {
              if (type === "paServiceRegister") {
                handleDeleteService(rowIndex);
              } else {
                handleDeleteDrugs(rowIndex);
              }
            }}
          >
            <IconDelete />
          </span>
        );
      },
    },
    {
      title: "Mã DV/SP",
      width: "5%",
      render: ({ item, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {item?.service?.code}
              {item?.baseServiceId && (
                <div>
                  <span style={{ color: "red", fontSize: "10px" }}>
                    (Dịch vụ khuyến mãi)
                  </span>
                </div>
              )}
              {item?.unLimited ? (
                <Tooltip title="Không giới hạn">
                  <span className="unlimited-badge"> ♾️</span>
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          );
        } else {
          return (
            <>
              {item?.drug?.code}

              {item?.baseServiceId && (
                <div>
                  <span style={{ color: "red", fontSize: "10px" }}>
                    (Sản phẩm khuyến mãi)
                  </span>
                </div>
              )}
            </>
          );
        }
      },
    },
    {
      title: "Tên DV/SP",
      width: "8%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsPagingAutocomplete
                  name={`paServiceRegister[${rowIndex}].service`}
                  label=""
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  onChange={(_, value) => {
                    handleOnChangeService(value, rowIndex);
                  }}
                  api={pagingHealthCareService}
                  searchObject={{
                    isApply: true,
                    isUse: true,
                    serviceGroupIds:
                      values?.clientCard?.serviceGroups?.map(
                        (item) => item?.serviceGroup?.id
                      ) || [],
                    departmentId: values?.department?.id
                  }}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  getOptionLabel={(option) =>
                    option?.tradeName || option?.name || ""
                  }
                  searchFields={["tradeName", "name", "code"]}
                  renderOption={(option) => renderOptionsService(option)}
                />
              ) : (
                item?.service?.tradeName || item?.service?.name
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsPagingAutocomplete
                  name={`drugs[${rowIndex}].drug`}
                  api={pagingDrug}
                  searchObject={{
                    abstractProductIds:
                      values?.clientCard?.abstractProducts?.map(
                        (item) => item?.abstractProduct?.id
                      ) || [],
                    isUsing: true,
                    isApply: true,
                  }}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  onChange={(_, value) => {
                    handleOnChangeDrug(value, rowIndex);
                  }}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  getOptionLabel={(option) =>
                    option?.tradeName || option?.name || ""
                  }
                  searchFields={["tradeName", "name", "code"]}
                  renderOption={(option) => renderOptionsDrug(option)}
                />
              ) : (
                item?.drug?.tradeName || item?.drug?.name
              )}
            </>
          );
        }
      },
    },

    {
      title: "Điều trị",
      width: "4%",
      align: "center",
      render: ({ item, type }) => {
        if (type === "paServiceRegister") {
          return (
            <div>
              <b>{item?.totalPerformedTimes || 0}</b>
              {!item?.unLimited && (
                <>
                  <span> / </span>
                  <b style={{ color: "red" }}>
                    {item?.totalTreatmentTimes || 0}
                  </b>
                </>
              )}
            </div>
          );
        }
        return null;
      },
    },

    {
      title: "Tên đăng kí",
      width: "8%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <GlobitsTextField
                // disabled={hasPaidStatus(item?.paymentStatus)}
                name={`paServiceRegister[${rowIndex}].name`}
              />
            </>
          );
        } else {
          return (
            <>
              <GlobitsTextField
                // disabled={hasPaidStatus(item?.paymentStatus)}
                name={`drugs[${rowIndex}].name`}
              />
            </>
          );
        }
      },
    },
    {
      title: "Số lượng",
      width: "4%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          let isTreatmentTypeVolume =
            item?.service?.serviceTreatmentType ===
            SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME;
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <>
                    <GlobitsNumberInput
                      name={`paServiceRegister[${rowIndex}].quantity`}
                      disabled={
                        hasPaidStatus(item?.paymentStatus) ||
                        item?.isDisabledCTKM
                      }
                      onChange={async (e) => {
                        const quantity = +e?.target?.value;
                        await setFieldValue(
                          `paServiceRegister[${rowIndex}].quantity`,
                          quantity
                        );

                        handleOnchangeQuantityService(e, rowIndex);
                      }}
                    />
                    <Tooltip title="Số lượng * số lần được điều trị trong danh mục phải lớn hơn số lần đã điều trị">
                      <Info
                        className="ml-1 mb-1"
                        fontSize="small"
                        color="primary"
                      />
                    </Tooltip>
                  </>
                ) : (
                  <>
                    {/* {isTreatmentTypeVolume ? (
                      <>{item?.totalTreatmentTimes}</>
                    ) : (
                    )} */}
                    <>{item?.quantity}</>
                  </>
                )}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <>
                    <GlobitsNumberInput
                      name={`drugs[${rowIndex}].soldQuantity`}
                      disabled={
                        hasPaidStatus(item?.paymentStatus) ||
                        item?.isDisabledCTKM
                      }
                      onChange={async (e) => {
                        const soldQuantity = +e?.target?.value;
                        await setFieldValue(
                          `drugs[${rowIndex}].soldQuantity`,
                          soldQuantity
                        );
                        handleOnchangeQuantityDrug(e, rowIndex);
                      }}
                    />
                    <Tooltip title="Số lượng * số lần được điều trị trong danh mục phải lớn hơn số lần đã điều trị">
                      <Info
                        className="ml-1 mb-1"
                        fontSize="small"
                        color="primary"
                      />
                    </Tooltip>
                  </>
                ) : (
                  item?.soldQuantity
                )}
              </div>
            </>
          );
        }
      },
    },
    {
      title: "Số cc bán",
      width: "2%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <>
                    <GlobitsNumberInput
                      name={`paServiceRegister[${rowIndex}].totalVolumeSold`}
                      disabled={!isAdmin()}
                      decimal
                      roundNumberToFixed={2}
                    />
                  </>
                ) : (
                  item?.totalVolumeSold
                )}
              </div>
            </>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      title: "Loại giá",
      width: "7%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsAutocomplete
                  options={values?.paServiceRegister?.[rowIndex]?.fees}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  onChange={(_, value) => {
                    handleOnChangePatientTypeServiceService(value, rowIndex);
                  }}
                  name={`paServiceRegister[${rowIndex}].patientTypeService`}
                  getOptionLabel={(option) => {
                    return option?.patientTypeService?.name
                      ? `${option.patientTypeService?.name}
                                      `
                      : option?.name
                        ? option?.name
                        : "";
                  }}
                />
              ) : (
                item?.patientTypeService?.patientTypeService?.name || item?.patientTypeService?.name || ""
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsAutocomplete
                  options={values?.drugs?.[rowIndex]?.fees}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  onChange={(_, value) => {
                    handleOnChangePatientTypeServiceDrug(value, rowIndex);
                  }}
                  name={`drugs[${rowIndex}].patientTypeService`}
                  getOptionLabel={(option) => {
                    return option?.patientTypeService?.name
                      ? `${option.patientTypeService?.name}
                                      `
                      : option?.name
                        ? option?.name
                        : "";
                  }}
                />
              ) : (
                item?.patientTypeService?.patientTypeService?.name || item?.patientTypeService?.name || item?.name
              )}
            </>
          );
        }
      },
    },

    {
      title: "Đơn giá",
      width: "6%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  /*
                  Disable nếu:
                  - Giá dịch vụ không được điều chỉnh & không có quyền thanh toán (khi cấu hình ràng buộc phải có quyền thanh toán được bật)
                  - Đã thanh toán
                  - Bị khóa bởi CTKM
                  */
                  disabled={
                    (!item?.patientTypeService?.isEditable && PERMISSION_ROLE_HIS_PAYMENT && !isPaymentPermission) ||
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM
                  }
                  isOnlyOnChange
                  name={`paServiceRegister[${rowIndex}].price`}
                  onChange={async (e) => {
                    const price = e?.target?.value;
                    await setFieldValue(
                      `paServiceRegister[${rowIndex}].price`,
                      price
                    );
                    await handleOnchangePriceService(e, rowIndex);
                  }}
                />
              ) : (
                formatMoney(item?.price)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  /*
                  Disable nếu:
                  - Giá dịch vụ không được điều chỉnh & không có quyền thanh toán (khi cấu hình ràng buộc phải có quyền thanh toán được bật)
                  - Đã thanh toán
                  - Bị khóa bởi CTKM
                  */
                  disabled={
                    (!item?.patientTypeService?.isEditable && PERMISSION_ROLE_HIS_PAYMENT && !isPaymentPermission) ||
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM
                  }
                  isOnlyOnChange
                  name={`drugs[${rowIndex}].price`}
                  onChange={async (e) => {
                    const price = e?.target?.value;
                    await setFieldValue(`drugs[${rowIndex}].price`, price);
                    await handleOnchangePriceDrug(e, rowIndex);
                  }}
                />
              ) : (
                formatNumber(item?.price)
              )}
            </>
          );
        }
      },
    },
    {
      title: "Chương trình khuyến mãi",
      width: "7%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsPagingAutocomplete
                  api={pagingProgram}
                  searchObject={{
                    codes: listFreeCode,
                    productCode: item?.service?.code,
                    isPaying: false,
                  }}
                  name={`paServiceRegister[${rowIndex}].promotionProgram`}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  getOptionDisabled={(option) => {
                    // Lấy giá trị hiện tại từ values: đơn giá * số lượng - tiền khấu trừ (nếu có)
                    const currentItem = getIn(values, `paServiceRegister[${rowIndex}]`);
                    const currentAmount = ((currentItem?.price || 0) * (currentItem?.quantity || 1)) - (currentItem?.oldCredit || 0);
                    // Disable option nếu giá trị đơn hàng tối thiểu > 0 và thành tiền < giá trị đơn hàng tối thiểu
                    if (option?.minInvoiceAmount > 0 && currentAmount < option?.minInvoiceAmount) {
                      return true;
                    }
                    return false;
                  }}
                  onChange={(_, value) => {
                    console.log("value", value);

                    setFieldValue(
                      `paServiceRegister[${rowIndex}].promotionProgram`,
                      value
                    );

                    if (!value) {
                      // Lấy item hiện tại để tính lại thành tiền
                      const currentItem = getIn(values, `paServiceRegister[${rowIndex}]`);
                      const price = currentItem?.price || 0;
                      const quantity = currentItem?.quantity || 1;
                      const newAmount = price * quantity;

                      setFieldValue(
                        `paServiceRegister[${rowIndex}].discount`,
                        0
                      );

                      setFieldValue(
                        `paServiceRegister[${rowIndex}].percentDiscount`,
                        0
                      );

                      // Cập nhật lại thành tiền khi bỏ chọn CTKM
                      setFieldValue(
                        `paServiceRegister[${rowIndex}].amount`,
                        newAmount
                      );
                    }
                  }}
                />
              ) : (
                item?.promotionProgram?.name
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsPagingAutocomplete
                  name={`drugs[${rowIndex}].promotionProgram`}
                  api={pagingProgram}
                  searchObject={{
                    codes: listFreeCode,
                    productCode: item?.drug?.code,
                    isPaying: false,
                  }}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) || item?.isDisabledCTKM
                  }
                  getOptionDisabled={(option) => {
                    // Lấy giá trị hiện tại từ values: đơn giá * số lượng - tiền khấu trừ (nếu có)
                    const currentItem = getIn(values, `drugs[${rowIndex}]`);
                    const currentAmount = ((currentItem?.price || 0) * (currentItem?.soldQuantity || 1)) - (currentItem?.oldCredit || 0);
                    // Disable option nếu giá trị đơn hàng tối thiểu > 0 và thành tiền < giá trị đơn hàng tối thiểu
                    if (option?.minInvoiceAmount > 0 && currentAmount < option?.minInvoiceAmount) {
                      return true;
                    }
                    return false;
                  }}
                  onChange={(_, value) => {
                    setFieldValue(`drugs[${rowIndex}].promotionProgram`, value);
                    if (!value) {
                      // Lấy item hiện tại để tính lại thành tiền
                      const currentItem = getIn(values, `drugs[${rowIndex}]`);
                      const price = currentItem?.price || 0;
                      const soldQuantity = currentItem?.soldQuantity || 1;
                      const newAmount = price * soldQuantity;

                      setFieldValue(`drugs[${rowIndex}].discount`, 0);
                      setFieldValue(`drugs[${rowIndex}].percentDiscount`, 0);

                      // Cập nhật lại thành tiền khi bỏ chọn CTKM
                      setFieldValue(`drugs[${rowIndex}].amount`, newAmount);
                    }
                  }}
                />
              ) : (
                item?.promotionProgram?.name
              )}
            </>
          );
        }
      },
    },

    {
      title: "Giảm giá(%)",
      width: "5%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsNumberInput
                  name={`paServiceRegister[${rowIndex}].percentDiscount`}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM ||
                    (REQUIRED_CTKM_DISCOUNT && !item?.promotionProgram)
                  }
                  onChange={(e) => {
                    handleOnChangeServicesPercentDiscount(e, rowIndex);
                  }}
                  maxValue={100}
                />
              ) : (
                formatNumber(item?.percentDiscount)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsNumberInput
                  name={`drugs[${rowIndex}].percentDiscount`}
                  disabled={
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM ||
                    (REQUIRED_CTKM_DISCOUNT && !item?.promotionProgram)
                  }
                  onChange={(e) => {
                    handleOnChangeDrugsPercentDiscount(e, rowIndex);
                  }}
                  maxValue={100}
                />
              ) : (
                formatNumber(item?.percentDiscount)
              )}
            </>
          );
        }
      },
    },

    {
      title: "Giảm giá(tiền)",
      width: "5%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  isOnlyOnChange
                  disabled={
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM ||
                    (REQUIRED_CTKM_DISCOUNT && !item?.promotionProgram)
                  }
                  name={`paServiceRegister[${rowIndex}].discount`}
                  onChange={(e) => {
                    handleOnChangeServiceDiscount(e, rowIndex);
                  }}
                />
              ) : (
                formatMoney(item?.discount)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  disabled={
                    hasPaidStatus(item?.paymentStatus) ||
                    item?.isDisabledCTKM ||
                    (REQUIRED_CTKM_DISCOUNT && !item?.promotionProgram)
                  }
                  isOnlyOnChange
                  name={`drugs[${rowIndex}].discount`}
                  onChange={(e) => {
                    handleOnChangeDrugsDiscount(e, rowIndex);
                  }}
                />
              ) : (
                formatMoney(item?.discount)
              )}
            </>
          );
        }
      },
    },

    {
      title: "Thành tiền",
      width: "5%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  isOnlyOnChange
                  name={`paServiceRegister[${rowIndex}].amount`}
                  disabled

                // onChange={(e) => {
                //   handleOnChangeServiceDiscount(e, rowIndex);
                // }}
                />
              ) : (
                formatMoney(item?.amount)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  isOnlyOnChange
                  name={`drugs[${rowIndex}].amount`}
                  disabled
                // onChange={(e) => {
                //   handleOnChangeDrugsDiscount(e, rowIndex);
                // }}
                />
              ) : (
                formatMoney(item?.amount)
              )}
            </>
          );
        }
      },
    },
    {
      title: "Khấu trừ",
      width: "5%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  disabled={hasPaidStatus(item?.paymentStatus)}
                  isOnlyOnChange
                  name={`paServiceRegister[${rowIndex}].oldCredit`}
                  onChange={async (e) => {
                    await handleOnChangeServiceOldCredit(e, rowIndex);
                  }}
                />
              ) : (
                formatMoney(item?.oldCredit)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsVNDCurrencyInputOnlyChange
                  disabled={hasPaidStatus(item?.paymentStatus)}
                  isOnlyOnChange
                  name={`drugs[${rowIndex}].oldCredit`}
                  onChange={async (e) => {
                    await handleOnChangeDrugsOldCredit(e, rowIndex);
                  }}
                />
              ) : (
                formatMoney(+item?.oldCredit)
              )}
            </>
          );
        }
      },
    },
    {
      title: "Tiền thuế(%)",
      width: "5%",
      isHide: true,

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsAutocompleteTextAndSelect
                  options={listVatPercent || []}
                  name={`paServiceRegister[${rowIndex}].taxPercent`}
                  disabled={getIn(
                    values,
                    `paServiceRegister.[${rowIndex}].priceWithTax`
                  )}
                  value={getIn(
                    values,
                    `paServiceRegister.[${rowIndex}].taxPercent`
                  )}
                  onInputChange={(newValue) => {
                    const price = getIn(
                      values,
                      `paServiceRegister.[${rowIndex}].price`
                    );

                    const discount =
                      getIn(
                        values,
                        `paServiceRegister.[${rowIndex}].discount`
                      ) || 0;

                    const newTaxTotal = ((price - discount) * newValue) / 100;
                    handleOnchangeTaxTotalServices(newTaxTotal, rowIndex);

                    setFieldValue(
                      `paServiceRegister.[${rowIndex}].taxTotal`,
                      newTaxTotal
                    );

                    setFieldValue(
                      `paServiceRegister.[${rowIndex}].taxPercent`,
                      newValue?.toString()
                    );
                  }}
                  displayLabel={"vatPercent"}
                  onChange={(value) => {
                    const price = getIn(
                      values,
                      `paServiceRegister.[${rowIndex}].price`
                    );
                    const discount =
                      getIn(
                        values,
                        `paServiceRegister.[${rowIndex}].discount`
                      ) || 0;
                    const newTaxTotal =
                      (value?.vatPercent * (price - discount)) / 100;
                    handleOnchangeTaxTotalServices(newTaxTotal, rowIndex);

                    setFieldValue(
                      `paServiceRegister.[${rowIndex}].taxTotal`,
                      newTaxTotal
                    );

                    setFieldValue(
                      `paServiceRegister.[${rowIndex}].taxPercent`,
                      value?.vatPercent?.toString()
                    );
                  }}
                />
              ) : (
                item?.taxPercent
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsAutocompleteTextAndSelect
                  options={listVatPercent || []}
                  name={`drugs[${rowIndex}].taxPercent`}
                  disabled={getIn(values, `drugs.[${rowIndex}].priceWithTax`)}
                  value={getIn(values, `drugs.[${rowIndex}].taxPercent`)}
                  onInputChange={(newValue) => {
                    const price = getIn(values, `drugs.[${rowIndex}].price`);

                    const discount =
                      getIn(values, `drugs.[${rowIndex}].discount`) || 0;

                    setFieldValue(
                      `drugs.[${rowIndex}].taxPercent`,
                      newValue?.toString()
                    );
                    const newTaxTotal = ((price - discount) * newValue) / 100;
                    handleOnchangeTaxTotalDrugs(newTaxTotal, rowIndex);
                    setFieldValue(`drugs.[${rowIndex}].taxTotal`, newTaxTotal);
                  }}
                  displayLabel={"vatPercent"}
                  onChange={(value) => {
                    const price = getIn(values, `drugs.[${rowIndex}].price`);
                    setFieldValue(
                      `drugs.[${rowIndex}].taxPercent`,
                      value?.vatPercent?.toString()
                    );
                    const discount =
                      getIn(values, `drugs.[${rowIndex}].discount`) || 0;

                    const newTaxTotal =
                      (value?.vatPercent * (price - discount)) / 100;
                    handleOnchangeTaxTotalDrugs(newTaxTotal, rowIndex);

                    setFieldValue(`drugs.[${rowIndex}].taxTotal`, newTaxTotal);
                  }}
                />
              ) : (
                item?.taxPercent
              )}
            </>
          );
        }
      },
    },

    {
      title: "Giá kèm thuế hay không",
      width: "6%",
      isHide: true,

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsCheckBox
                  name={`paServiceRegister[${rowIndex}].priceWithTax`}
                  alignPosition="center"
                  disabled
                />
              ) : (
                <GlobitsCheckBox
                  checked={!!item?.priceWithTax}
                  alignPosition="center"
                  disabled
                />
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsCheckBox
                  name={`drugs[${rowIndex}].priceWithTax`}
                  alignPosition="center"
                  disabled
                />
              ) : (
                <GlobitsCheckBox
                  checked={!!item?.priceWithTax}
                  alignPosition="center"
                  disabled
                />
              )}
            </>
          );
        }
      },
    },

    {
      title: "Không giới hạn sử dụng",
      width: "6%",
      isHide: true,

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsCheckBox
                  name={`paServiceRegister[${rowIndex}].unLimited`}
                  alignPosition="center"
                // disabled
                />
              ) : item?.unLimited ? (
                "✓"
              ) : (
                ""
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsCheckBox
                  name={`drugs[${rowIndex}].unLimited`}
                  alignPosition="center"
                // disabled
                />
              ) : item?.unLimited ? (
                "✓"
              ) : (
                ""
              )}
            </>
          );
        }
      },
    },
    {
      title: "Bảo hành",
      width: "2%",
      align: "center",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <div>
                {(editable || isEditWarranty) ? (
                  <>
                    <GlobitsCheckBox
                      name={`paServiceRegister[${rowIndex}].hasWarranty`}
                      alignPosition={"center"}
                      onChange={(event) => {
                        const isChecked = event.target.checked;
                        setFieldValue(
                          `paServiceRegister[${rowIndex}].hasWarranty`,
                          isChecked
                        );
                        if (isChecked) {
                          const warrantyPeriods =
                            item?.service?.warrantyPeriods;
                          //  (giá*số lượng - giảm giá)/số lượng
                          if (item?.quantity > 0) {
                            let amountItemWarranty =
                              (item?.price * item?.quantity -
                                (item?.discount || 0)) /
                              item?.quantity;
                            const warrantyPeriod = getWarrantyPeriods(
                              amountItemWarranty,
                              warrantyPeriods
                            );

                            setFieldValue(
                              `paServiceRegister[${rowIndex}].warrantyUnit`,
                              warrantyPeriod?.warrantyUnit
                            );
                            setFieldValue(
                              `paServiceRegister[${rowIndex}].warrantyDuration`,
                              warrantyPeriod?.warrantyQuantity
                            );
                            setFieldValue(
                              `paServiceRegister[${rowIndex}].warrantyTotalTimes`,
                              warrantyPeriod?.warrantyTimes
                            );
                          }
                        } else {
                          setFieldValue(
                            `paServiceRegister[${rowIndex}].warrantyUnit`,
                            null
                          );
                          setFieldValue(
                            `paServiceRegister[${rowIndex}].warrantyDuration`,
                            null
                          );
                          setFieldValue(
                            `paServiceRegister[${rowIndex}].warrantyTotalTimes`,
                            0
                          );
                        }
                      }}
                      disabled={hasPaidStatus(item?.paymentStatus) && !isEditWarranty}
                    />
                  </>
                ) : (
                  <GlobitsCheckBox
                    checked={!!item?.hasWarranty}
                    alignPosition="center"
                    disabled
                  />
                )}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div></div>
            </>
          );
        }
      },
    },
    {
      title: "Thời gian BH",
      width: "2%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <>
                    <GlobitsNumberInput
                      name={`paServiceRegister[${rowIndex}].warrantyDuration`}
                      disabled={
                        hasPaidStatus(item?.paymentStatus) ||
                        !item?.hasWarranty
                        // || !isAdminPermission
                      }
                    />
                  </>
                ) : (
                  item?.warrantyDuration
                )}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div style={{ display: "flex" }}></div>
            </>
          );
        }
      },
    },
    {
      title: "Đơn vị BH",
      width: "4%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <GlobitsSelectInput
                    options={LIST_DATE_UNIT}
                    name={`paServiceRegister[${rowIndex}].warrantyUnit`}
                    disabled={
                      hasPaidStatus(item?.paymentStatus) ||
                      !item?.hasWarranty
                      //  || !isAdminPermission
                    }
                  />
                ) : (
                  <span>
                    {LIST_DATE_UNIT.find((u) => u.value === item?.warrantyUnit)
                      ?.name || ""}
                  </span>
                )}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div style={{ display: "flex" }}></div>
            </>
          );
        }
      },
    },
    {
      title: "Tổng số lần được BH",
      width: "2%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <div style={{ display: "flex" }}>
                {editable ? (
                  <>
                    <GlobitsNumberInput
                      name={`paServiceRegister[${rowIndex}].warrantyTotalTimes`}
                      disabled={
                        hasPaidStatus(item?.paymentStatus) ||
                        !item?.hasWarranty
                        // || !isAdminPermission
                      }
                    />
                  </>
                ) : (
                  item?.warrantyTotalTimes
                )}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div style={{ display: "flex" }}></div>
            </>
          );
        }
      },
    },
    {
      title: "Ngày hết hạn bảo hành",
      width: "5%",

      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              {editable ? (
                <GlobitsDateTimePicker
                  name={`paServiceRegister[${rowIndex}].warrantyExpiryDate`}
                  isDateTimePicker
                  disabled={true}
                />
              ) : (
                getDate(item?.warrantyExpiryDate)
              )}
            </>
          );
        } else {
          return (
            <>
              {editable ? (
                <GlobitsDateTimePicker
                  name={`drugs[${rowIndex}].expiryDate`}
                  isDateTimePicker
                  disabled={values?.drugs?.[rowIndex]?.unLimited}
                />
              ) : (
                item?.expiryDate
              )}
            </>
          );
        }
      },
    },
    {
      title: "Ghi chú",
      width: "12%",
      render: ({ item, rowIndex, fullIndex, editable, type }) => {
        if (type === "paServiceRegister") {
          return (
            <>
              <GlobitsTextField
                isTextArea
                name={`paServiceRegister[${rowIndex}].note`}
              />
            </>
          );
        } else {
          return (
            <>
              <GlobitsTextField isTextArea name={`drugs[${rowIndex}].note`} />
            </>
          );
        }
      },
    },
  ];

  const handleResetWarrantyPeriod = (index) => {
    setFieldValue(`paServiceRegister[${index}].hasWarranty`, false);
    setFieldValue(`paServiceRegister[${index}].warrantyUnit`, null);
    setFieldValue(`paServiceRegister[${index}].warrantyDuration`, null);
    setFieldValue(`paServiceRegister[${index}].warrantyTotalTimes`, 0);
  };

  const groups = [
    {
      key: "paServiceRegister",
      label: "🔹 Dịch vụ",
      items: values.paServiceRegister || [],
      getIndex: (rowIndex) => rowIndex,
    },
    {
      key: "drugs",
      label: "💊 Sản phẩm",
      items: values.drugs || [],
      getIndex: (rowIndex) =>
        (values.paServiceRegister?.length || 0) + rowIndex,
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      groups={groups}
      showMoreButton
      name="paServiceRegisterTable"
      fitContainer
      editableMap={(item) => {
        const showDelete =
          item?.paymentStatus === undefined ||
          [INVOICE_NOREQUIRED_PAID, INVOICE_UNPAID].includes(
            item?.paymentStatus
          );
        const isEditable =
          (item?.isEditable || item?.currentEdit) && showDelete;
        return isEditable;
      }}
    />
  );
};

export const renderOptionsService = (option) => {
  const feeItemService =
    option?.serviceFeeList?.length > 0
      ? getPriceTypeService(null, option?.serviceFeeList || [])
      : null;
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.tradeName || option?.name} -{option?.code}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {feeItemService?.patientTypeService && (
          <div
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {feeItemService?.patientTypeService?.name}:{" "}
            <strong>
              {feeItemService?.price?.toLocaleString("vi-VN") || 0}
            </strong>
          </div>
        )}
      </div>
    </div>
  );
};

export const renderOptionsDrug = (option) => {
  const feeItemDrug =
    option?.drugUnitPrices?.length > 0
      ? getPriceTypeService(null, option?.drugUnitPrices || [])
      : null;
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.tradeName || option?.name} -{option?.code}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {feeItemDrug?.patientTypeService && (
          <div
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {feeItemDrug?.patientTypeService?.name}:{" "}
            <strong>{feeItemDrug?.price?.toLocaleString("vi-VN") || 0}</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(PaServiceRegisterTable);
